module.exports = __webpack_public_path__ + "static/media/高分二号卫星.47940ee2.png";